/* eslint-disable no-restricted-globals */
import React, { useLayoutEffect, useState } from "react";
import { Grid } from "@mui/material";

import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import ContestLeaderBoard from "./components/ContestLeaderBoard";
import TopPerformers from "./components/TopPerformers";

function Leaderboard() {
  const [initialLoading, setInitialLoading] = useState(true); // to skip fetch leaderboard api on initial loading
  const [filters, setFilters] = useState({
    location: [],
    team: [],
    user: [],
    role: [],
    reportsTo: [],
    dateFilter: "Today",
    startDate: "",
    endDate: "",
  }); // filter modal values
  const [columns, setColumns] = useState({
    other: ["totalKpis", "totalPoints"],
    kpis: [],
  }); // columns contains only value of selected columns without it's name to easily manage it via URL and table filters
  const [tableFilterOptionsLoading, setTableFilterOptionsLoading] = useState(true);
  const [tableFilterOptions, setTableFilterOptions] = useState({
    other: [
      {
        id: "totalKpis",
        name: "Completed KPIs",
      },
      {
        id: "totalPoints",
        name: "Achieved Points",
      },
    ],
    kpis: [],
  }); // filters dropdown options for table columns
  const [lastRefreshedOn, setLastRefreshedOn] = useState(); // use to refresh data after 30 min

  useLayoutEffect(() => {
    // Closure to keep track of the first render
    let isFirstRender = true;

    // Refetch data in every 30 minute interval and skip for first time
    const fetchInterval = setInterval(
      () => {
        if (!isFirstRender) {
          setLastRefreshedOn(new Date().getTime());
        } else {
          isFirstRender = false;
        }
      },
      1000 * 60 * 5
    );

    // Clear interval on component unmount
    return () => clearInterval(fetchInterval);
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox className="leaderboard-container">
        <Grid item xs={12} sm={12} md={12} lg={4}>
          <TopPerformers
            filters={filters}
            columns={columns}
            tableFilterOptions={tableFilterOptions}
            initialLoading={initialLoading}
            lastRefreshedOn={lastRefreshedOn}
            tableFilterOptionsLoading={tableFilterOptionsLoading}
          />
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <ContestLeaderBoard
              history={history}
              filters={filters}
              setFilters={setFilters}
              columns={columns}
              setColumns={setColumns}
              initialLoading={initialLoading}
              setInitialLoading={setInitialLoading}
              lastRefreshedOn={lastRefreshedOn}
              tableFilterOptions={tableFilterOptions}
              setTableFilterOptions={setTableFilterOptions}
              tableFilterOptionsLoading={tableFilterOptionsLoading}
              setTableFilterOptionsLoading={setTableFilterOptionsLoading}
            />
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Leaderboard;
